import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function (e) {
    const homeHeaderSlides = e.target.querySelector('.home-header__slides')

    if (homeHeaderSlides) {
        const splideInstance = new Splide('.js-slides-slider', {
            arrows: false,
            perMove : 1,
            perPage: 1,
            gap: '30px',
        })
        splideInstance.mount()
    }

    const button = document.getElementById('js-floating-btn');
    if (button) {
        const header = document.querySelector('.home-header');

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) {
                        button.style.display = 'flex';
                    } else {
                        button.style.display = 'none';
                    }
                });
            }
        );

        observer.observe(header);
    }
})
